import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Builder } from 'builder-pattern';
import { catchError, first, Observable, throwError } from 'rxjs';
import { CarbonCreditRequest, CarbonCreditResponse } from 'src/app/shared/interfaces/carbon-credit-request';
import { PostApi } from 'src/app/shared/interfaces/response-api';
import { extractDocumentCharacters } from 'src/app/helpers/utils/cpf-cnpj.util';
import { AppConfigService } from 'src/environments/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class CreditRegisterService {
  private environment: any
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient,
    private datePipe: DatePipe,
    private appConfig: AppConfigService
  ) {
    this.environment = this.appConfig.config;
    this.apiUrl = `${this.environment.apiIssuer}/instruments`
  }

  public checkInvestor(documentNumber: string, accountCode: string): Observable<any> {
    const url = `${this.environment.apiIssuer}/investors/check`;
    const params = new HttpParams()
      .set('documentNumber', extractDocumentCharacters(documentNumber))
      .set('accountCode', accountCode);

    return this.httpClient.get<any>(url, { params }).pipe(
      first(),
      catchError(err => throwError(() => err))
    );
  }

  public creditRegister(form: any): Observable<CarbonCreditResponse> {
    const carbonCredit = this.mapperCarbonCredit(form);
    const body: PostApi<CarbonCreditRequest> = {
      data: carbonCredit
    }
    return this.httpClient.post<CarbonCreditResponse>(this.apiUrl, body).pipe(
      first(),
      catchError(err => {
        const payload = err.error;

        if (payload?.code) {
          return throwError(() => payload);
        }

        if (Array.isArray(payload) && payload[0]?.code) {
          return throwError(() => payload[0]);
        }

        return throwError(() => err);
      })
    );
  }

  public mapperCarbonCredit(form: any): CarbonCreditRequest {
    const request = Builder<CarbonCreditRequest>()
      .creditQuantity(Number(form.creditQuantity))
      .observationText(form.description || '')
      .cpfCnpjCode(form.cnpj)
      .certifierDescription(form.certifier?.label)
      .registerCode(form.registerNumber)
      .holderCode(form.holderNumber)
      .financialInstrumentTypeCode('CARB')
      .issueDate(this.datePipe.transform(form.data, 'yyyy-MM-dd') || '')

      .certifierId(form.certifier?.inputId)
      .vintageStart(this.datePipe.transform(form.safraIDate, 'yyyy-MM-dd') || '')
      .vintageEnd(this.datePipe.transform(form.safraFDate, 'yyyy-MM-dd') || '')
      .serialCode(form.serialCode)
      .projectId(form.projectId)
      .projectName(form.projectName)
      .projectLink(form.linkProject)
      .brcerIndicator(Boolean(form.brcerAccepted))
      .build();

    if (form.holderCpfCnpj) {
      request.investor = { documentNumber: extractDocumentCharacters(form.holderCpfCnpj) };
    }

    return request;
  }

}
